import { createContext, useContext } from 'react';

export const ChatSessionContext = createContext(null);

export function useChatSession() {
  return useContext(ChatSessionContext);
}
